import gql from 'graphql-tag';

export const createOrUpdateGame = gql`
	mutation createOrUpdateGame($game: GameInput!) {
		createOrUpdateGame(game: $game) {
			id
			airings {
				items {
					id
					channelId
					startTime
					businessLogic
					status
				}
			}
			sport
			startTime
			title
			offsets {
				items {
					segment
					offset
				}
			}
		}
	}
`;

export const deleteAiring = gql`
	mutation deleteAiring($id: ID!) {
		deleteAiring(id: $id) {
			id
		}
	}
`;

export const createAiring = gql`
	mutation createAiring($airing: AiringInput!, $gameId: ID!, $mafStage: String, $action: String) {
		createAiring(airing: $airing, gameId: $gameId, mafStage: $mafStage, action: $action) {
			businessLogic
			channelId
			id
			status
			startTime
		}
	}
`;

export const updateAiring = gql`
	mutation updateAiring($airing: AiringInput!, $gameId: ID!) {
		updateAiring(airing: $airing, gameId: $gameId) {
			businessLogic
			channelId
			id
			status
			startTime
			offsets
		}
	}
`;

export const createFer = gql`
	mutation createFer($fer: FerInput!) {
		createFer(fer: $fer) {
			ferId
		}
	}
`;

export const updateFer = gql`
	mutation updateFer($ferId: ID!, $fer: FerInput!) {
		updateFer(ferId: $ferId, fer: $fer) {
			ferId
		}
	}
`;

export const deleteFer = gql`
	mutation deleteFer($ferId: ID!, $gameId: ID!) {
		deleteFer(ferId: $ferId, gameId: $gameId) {
			ferId
		}
	}
`;

export const sendFerToHarvest = gql`
	mutation ferSendToHarvesting($ferId: ID!, $endTime: String!) {
		ferSendToHarvesting(ferId: $ferId, endTime: $endTime)
	}
`;
